import "/__w/1/s/BotFramework-WebChat/packages/fluent-theme/src/components/dropZone/DropZone.module_built.css";
const classes = {"sendbox__attachment-drop-zone":"wbibrda_sendbox__attachment-drop-zone","sendbox__attachment-drop-zone--droppable":"wbibrda_sendbox__attachment-drop-zone--droppable","sendbox__attachment-drop-zone-icon":"wbibrda_sendbox__attachment-drop-zone-icon"}
export default classes

const _sendbox__attachment_drop_zone0 = classes["sendbox__attachment-drop-zone"]
export { _sendbox__attachment_drop_zone0 as "sendbox__attachment-drop-zone" }

const _sendbox__attachment_drop_zone__droppable0 = classes["sendbox__attachment-drop-zone--droppable"]
export { _sendbox__attachment_drop_zone__droppable0 as "sendbox__attachment-drop-zone--droppable" }

const _sendbox__attachment_drop_zone_icon0 = classes["sendbox__attachment-drop-zone-icon"]
export { _sendbox__attachment_drop_zone_icon0 as "sendbox__attachment-drop-zone-icon" }
